import Vue from 'vue'
import Vuex from 'vuex'
import { login, logout, getUserInfo } from '@/api/auth'
import { setCookie } from '@/utils/request'
import { Message } from 'element-ui'

Vue.use(Vuex)

const getDefaultState = () => {
  // 从cookie获取token
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  return {
    token: getCookie('Java-merchantToken') || '',
    user: null,
    loading: false
  }
}

const state = getDefaultState()

export default new Vuex.Store({
  state,
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user
  },
  mutations: {
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      setCookie('Java-merchantToken', token)
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      const { account, pwd } = userInfo
      return new Promise((resolve, reject) => {
        login({ account: account.trim(), pwd: pwd }).then(response => {
          // 根据实际API响应，响应格式为 { code, data, message }
          if (response.code === 200) {
            const { data } = response
            commit('SET_TOKEN', data.token)
            commit('SET_USER', {
              username: data.account,
              realName: data.realName,
              account: data.account,
              isSms: data.isSms
            })
            Message.success('登录成功')
            resolve()
          } else {
            Message.error(response.message || '登录失败')
            reject(new Error(response.message || '登录失败'))
          }
        }).catch(error => {
          Message.error(error.message || '登录失败')
          reject(error)
        })
      })
    },

    // 获取用户信息
    getInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          const { data } = response
          if (!data) {
            reject('验证失败，请重新登录')
          }
          commit('SET_USER', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 用户登出
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(response => {
          // 检查响应码，登出成功码为0
          if (response.code === 200) {
            // 清除cookie中的token
            document.cookie = 'Java-merchantToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
            commit('RESET_STATE')
            Message.success('退出登录成功')
            resolve()
          } else {
            // 即使API返回错误码，也清除本地状态
            document.cookie = 'Java-merchantToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
            commit('RESET_STATE')
            Message.error(response.message || '退出登录失败')
            reject(new Error(response.message || '退出登录失败'))
          }
        }).catch(error => {
          // 清除cookie中的token
          document.cookie = 'Java-merchantToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
          commit('RESET_STATE')
          reject(error)
        })
      })
    },

    // 重置token
    resetToken({ commit }) {
      return new Promise(resolve => {
        // 清除cookie中的token
        document.cookie = 'Java-merchantToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        commit('RESET_STATE')
        resolve()
      })
    }
  },
  modules: {
  }
})
